<template>
  <div class="navBox">
    <div class="left">
      <ul>
        <template v-for="route of left">
          <NavTopItems :route="route" />
        </template>
      </ul>
    </div>
    <div class="logoBox">
      <div class="logoAndTitle">
        <img class="logo" src="@/assets/logo.svg" />
        <div class="title">华联校友网</div>
      </div>
    </div>
    <div class="right">
      <ul>
        <template v-for="route of right">
          <NavTopItems :route="route" />
        </template>
      </ul>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useRouter, useRoute } from '@/hooks/useRouter'
import NavTopItems from './NavTopItems.vue'

const router = useRouter()

const left = computed(() => {
  if (router.options.routes && router.options.routes.length > 1) {
    return router.options.routes.filter((i) => !i.meta?.hide).slice(1, 7)
  }
  return []
})
const right = computed(() => {
  if (router.options.routes && router.options.routes.length > 1) {
    return router.options.routes.filter((i) => !i.meta?.hide).slice(7, 13)
  }
  return []
})
</script>
<style lang="less" scoped>
.navBox {
  height: 50px;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  position: relative;
  .left {
    position: absolute;
    z-index: 20;
  }
  .right {
    position: absolute;
    right: 0;
    z-index: 20;
  }

  .logoBox {
    background-image: url('@/assets/navTop.png');
    width: 750px;
    height: 124px;
    position: absolute;
    top: -50px;
    left: calc(50% - 375px);
    z-index: 10;
    .logoAndTitle {
      position: absolute;
      left: calc(50% - 38px);
      top: 15px;
      color: #fff;
      text-align: center;
      .logo {
        width: 64px;
        height: 64px;
        user-select: none;
      }
      .title {
        margin-top: 4px;
        user-select: none;
      }
    }
  }
}
</style>
